import { render, staticRenderFns } from "./TooltipOption.vue?vue&type=template&id=140ef3ff&"
import script from "./TooltipOption.vue?vue&type=script&lang=js&"
export * from "./TooltipOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports